import React from "react";

import { minimumResponses } from "src/utils/minimum_thresholds";

import { ProgressCircle } from "./progress_circle";

/*
 * Types
 */

export interface ProgressCircleGroupProps {
    readonly constituentGroups: {
        fsci: Record<ConstituencyGroup, number>;
        ffi: Record<ConstituencyGroup, number>;
    };
    readonly submissionProgress: {
        fsci: Record<ConstituencyGroup, number>;
        ffi: Record<ConstituencyGroup, number>;
    };
    readonly surveysCompleted: {
        fsci: Record<ConstituencyGroup, number>;
        ffi: Record<ConstituencyGroup, number>;
    };
}

/*
 * Main
 */

export const ProgressCircleGroupCombined = (props: ProgressCircleGroupProps): React.ReactElement => {
    const { constituentGroups, surveysCompleted } = props;

    return (
        <div className="progress-circle-group">
            <div className="progress-circle-subgroup">
                <h2 className="progress-circle-subgroup-title">Students</h2>
                <ProgressCircle
                    data-testid="progress-circle-students"
                    totalCompleted={surveysCompleted.fsci.students}
                    totalRequired={minimumResponses("students", constituentGroups.fsci.students)}
                >
                    6th Grade+
                </ProgressCircle>
                <ProgressCircle
                    data-testid="progress-circle-students"
                    totalCompleted={surveysCompleted.ffi.students}
                    totalRequired={minimumResponses("students", constituentGroups.ffi.students)}
                >
                    8th Grade+
                </ProgressCircle>
            </div>
            <div className="progress-circle-subgroup">
                <h2 className="progress-circle-subgroup-title">School Staff</h2>
                <ProgressCircle
                    data-testid="progress-circle-teachers"
                    totalCompleted={surveysCompleted.fsci.teachers}
                    totalRequired={minimumResponses("teachers", constituentGroups.fsci.teachers)}
                >
                    Teachers
                </ProgressCircle>
                <ProgressCircle
                    data-testid="progress-circle-administrators"
                    totalCompleted={surveysCompleted.fsci.administrators}
                    totalRequired={minimumResponses("administrators", constituentGroups.fsci.administrators)}
                >
                    Administrators
                </ProgressCircle>
                <ProgressCircle
                    data-testid="progress-circle-supportStaff"
                    totalCompleted={surveysCompleted.fsci.supportStaff}
                    totalRequired={minimumResponses("supportStaff", constituentGroups.fsci.supportStaff)}
                >
                    Support Staff
                </ProgressCircle>
            </div>

            <div className="progress-circle-subgroup">
                <h2 className="progress-circle-subgroup-title">Other</h2>
                <ProgressCircle
                    data-testid="progress-circle-parents"
                    totalCompleted={surveysCompleted.fsci.parents}
                    totalRequired={minimumResponses("parents", constituentGroups.fsci.parents)}
                >
                    Parents
                </ProgressCircle>
                <ProgressCircle
                    data-testid="progress-circle-alumni"
                    totalCompleted={surveysCompleted.fsci.alumni}
                    totalRequired={minimumResponses("alumni", constituentGroups.fsci.alumni)}
                >
                    Alumni
                </ProgressCircle>
                <ProgressCircle
                    data-testid="progress-circle-boardMembers"
                    totalCompleted={surveysCompleted.fsci.boardMembers}
                    totalRequired={minimumResponses("boardMembers", constituentGroups.fsci.boardMembers)}
                >
                    Board Members
                </ProgressCircle>
            </div>
        </div>
    );
};
